// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file {\n    position: relative;\n}\n.file::before {\n    content: '';\n    display: block;\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    left: -25px;\n    top: 0;\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center;\n}\n.file.valid::before {\n    background-image: url(/valid.svg);\n}\n.file.error::before {\n    background-image: url(/error.svg);\n}\n.file label {\n    margin: 0 5px;\n}\n", ""]);
// Exports
module.exports = exports;
